import { useEntityNoticeSignupOtp } from '../../hooks/useEntityNoticeSignupOtp'
import { EmailOtpConfirmation } from '../email-otp-confirmation'

export interface EntityNoticeOtpStepProps {
  email: string
  onVerified: (token: string) => void
  onCloseClick?: () => void
}

/**
 * OTP confirmation for the entity-notice fake-door signup (cells A/B),
 * in-modal — reuses the shared presentational `EmailOtpConfirmation` (same
 * PinInput/countdown/resend UI as the standalone signup flow) but wires it
 * to `useEntityNoticeSignupOtp` instead of `useSignupOtp`: a valid code
 * never leaves the iframe (R2), it hands the token to `onVerified` so the
 * caller can advance to "Complete seus dados".
 *
 * QA2-5's four Figma divergences, resolved: h1+h2 split and the 120×120
 * illustration were already the shared component's default look (no change
 * needed); the 60s countdown and plain-text error were the two real gaps,
 * closed via `resendCountdownSeconds`/`errorVariant` — both opt-in, so the
 * standalone flow's own call-site is unaffected.
 */
export function EntityNoticeOtpStep({ email, onVerified, onCloseClick }: EntityNoticeOtpStepProps) {
  const { isLoading, error, setError, validateCode, resendCode } = useEntityNoticeSignupOtp({
    email,
    onVerified,
  })

  return (
    <EmailOtpConfirmation
      email={email}
      isLoading={isLoading}
      error={error}
      onComplete={validateCode}
      onResend={resendCode}
      onChangeEmail={() => undefined}
      onCodeChange={() => setError(undefined)}
      onCloseClick={onCloseClick}
      resendCountdownSeconds={15}
      errorVariant="banner"
    />
  )
}
